import { confirmable } from 'react-confirm';
import { useTranslation } from 'react-i18next';
import { useEffect, useMemo, useState } from 'react';
import StackedModal from './stacked_modal';
import { LabelSizeField } from './print_label_type_dialog';
import { PRINT_CATEGORY, useGetPrintCatalog } from 'src/api/print_center_api';

function PrintSizeConfirmDialog({ show, proceed, title, content, printType }) {
  const { t } = useTranslation('common');
  const [labelSize, setLabelSize] = useState('');
  const { searchResults: catalog } = useGetPrintCatalog(PRINT_CATEGORY.LABEL);

  const sizeCard = useMemo(
    () => catalog.find((item) => item.code === printType) ?? null,
    [catalog, printType],
  );

  useEffect(() => {
    setLabelSize((sizeCard?.sizes ?? []).find((size) => size.isDefault)?.code ?? '');
  }, [sizeCard]);

  return (
    <StackedModal
      isOpen={show}
      title={title || t('common:button.confirm')}
      content={content || t('common:confirmation.confirm')}
      footerLeftNode={
        <LabelSizeField
          card={sizeCard}
          value={labelSize}
          onChange={setLabelSize}
        />
      }
      primaryAction={{
        content: t('common:button.confirm'),
        onAction: () => proceed({ confirmed: true, labelSize }),
      }}
      onClose={() => proceed({ confirmed: false, labelSize: '' })}
    />
  );
}

export default confirmable(PrintSizeConfirmDialog);
